// @ts-nocheck
import { PurpleSelectTrigger } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/PurpleSelectTrigger';
import { PurpleSuffixInput } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/PurpleSuffixInput';
import { StyledPurpleSelectWrapper } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/styles';
import {
  StyledBasicSelect,
  EventConditionInputContainer,
  StyledPurpleTextInputSuffix,
} from '../Styled';
import { comparatorOptions } from '../constants';

export const OccurrencesCondition = ({ id, onUpdate, query = {} }) => {
  const { value, comparator } = query;

  const updateComparator = (newComparator) => {
    onUpdate({
      ...query,
      comparator: newComparator,
    });
  };

  const updateOccurrencesValue = (occurrencesValue) => {
    onUpdate({
      ...query,
      value: occurrencesValue,
    });
  };

  const getSuffix = (count) => {
    return count <= 1 ? (
      <StyledPurpleTextInputSuffix>{'time'}</StyledPurpleTextInputSuffix>
    ) : (
      <StyledPurpleTextInputSuffix>{'times'}</StyledPurpleTextInputSuffix>
    );
  };

  return (
    <EventConditionInputContainer data-test={`${id}_OccurrencesCondition`}>
      {
        <>
          <StyledBasicSelect
            id={`${id}_OccurrencesConditionComparator`}
            defaultValues={[comparator]}
            options={comparatorOptions.occurrences}
            onSelect={([newComparator]) => updateComparator(newComparator)}
            suffixUsed={true}
            SelectWrapper={StyledPurpleSelectWrapper}
            Trigger={PurpleSelectTrigger}
          />
          <PurpleSuffixInput
            id={`${id}_OccurrencesConditionValue`}
            isRequired={true}
            onChange={updateOccurrencesValue}
            type="text"
            value={value}
            data-test="occurrences-query-input"
            Suffix={getSuffix(value)}
          />
        </>
      }
    </EventConditionInputContainer>
  );
};
